export const KEY_OPTIONS = [
  {
    group: "Core Booking & Payment Notifications",
    options: [
      { value: "booking_confirmation", label: "Booking Confirmation" },
      {
        value: "booking_awaiting_payment",
        label: "Booking Awaiting Payment",
      },
      { value: "ticket_issued", label: "Ticket Issued" },
      { value: "ticketing_delay", label: "Ticketing Delay" },
      { value: "booking_expiry_warning", label: "Booking Expiry Warning" },
    ],
  },

  {
    group: "Post-Ticketing Management Notifications",
    options: [
      { value: "refund_approved", label: "Refund Approved" },
      { value: "refund_rejected", label: "Refund Rejected" },
      { value: "date_change_confirmed", label: "Date Change Confirmed" },
      { value: "name_change_confirmed", label: "Name Change Confirmed" },
      { value: "void_confirmed", label: "Void Confirmed" },
      {
        value: "baggage_add_on_confirmed",
        label: "Baggage Add-On Confirmed",
      },
    ],
  },

  {
    group: "Wallet & Finance Notifications",
    options: [
      { value: "wallet_deposit_success", label: "Wallet Deposit Success" },
      { value: "wallet_low_balance", label: "Wallet Low Balance" },
      { value: "wallet_payment_success", label: "Wallet Payment Success" },
      { value: "withdrawal_processed", label: "Withdrawal Processed" },
      { value: "failed_transaction", label: "Failed Transaction" },
    ],
  },

  {
    group: "Promotions & Reminders",
    options: [
      { value: "special_offer_alert", label: "Special Offer Alert" },
      { value: "loyalty_points_update", label: "Loyalty Points Update" },
      { value: "reactivation_reminder", label: "Reactivation Reminder" },
    ],
  },

  {
    group: "In-Trip Notifications",
    options: [
      {
        value: "gate_change_delay_alert",
        label: "Gate Change / Delay Alert",
      },
      { value: "transit_reminder", label: "Transit Reminder" },
    ],
  },

  {
    group: "Post-Travel Notifications",
    options: [
      { value: "welcome_back_message", label: "Welcome Back Message" },
      { value: "feedback_request", label: "Feedback Request" },
      { value: "loyalty_offer_alert", label: "Loyalty Offer Alert" },
    ],
  },

  {
    group: "Intraverse Pack – Pre-Travel (Agent → Customer)",
    options: [
      {
        value: "agent_booking_confirmation",
        label: "Agent Booking Confirmation",
      },
      { value: "payment_receipt", label: "Payment Receipt" },
      { value: "travel_reminder_24hrs", label: "Travel Reminder (24hrs)" },
      { value: "check_in_reminder", label: "Check-In Reminder" },
      { value: "visa_document_reminder", label: "Visa Document Reminder" },
    ],
  },

  {
    group: "Intraverse Pack – In-Trip (Agent → Customer)",
    options: [
      {
        value: "agent_gate_change_delay_alert",
        label: "Agent Gate Change / Delay Alert",
      },
      { value: "agent_transit_reminder", label: "Agent Transit Reminder" },
      {
        value: "arrival_notification_to_pickup",
        label: "Arrival Notification To Pickup",
      },
    ],
  },

  {
    group: "Intraverse Pack – Post-Travel (Agent → Customer)",
    options: [
      {
        value: "agent_welcome_back_message",
        label: "Agent Welcome Back Message",
      },
      { value: "agent_feedback_request", label: "Agent Feedback Request" },
      {
        value: "agent_loyalty_offer_alert",
        label: "Agent Loyalty Offer Alert",
      },
    ],
  },
];

export const TYPE_OPTIONS = [
  { value: "TEXT", label: "SMS / Text" },
  { value: "WHATSAPP", label: "WhatsApp" },
];
